"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: zoopraisal.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoopraisalResponse = exports.ZoopraisalRequest_Coordinates = exports.ZoopraisalRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
exports.protobufPackage = "domain";
function createBaseZoopraisalRequest() {
    return {
        position: undefined,
        homeType: "",
        bedrooms: 0,
        bathrooms: 0,
        sqft: 0,
        monthsAgo: 0,
        distance: 0,
        statusId: 0,
        standardStatus: "",
    };
}
exports.ZoopraisalRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.position !== undefined) {
            exports.ZoopraisalRequest_Coordinates.encode(message.position, writer.uint32(10).fork()).join();
        }
        if (message.homeType !== "") {
            writer.uint32(18).string(message.homeType);
        }
        if (message.bedrooms !== 0) {
            writer.uint32(24).int32(message.bedrooms);
        }
        if (message.bathrooms !== 0) {
            writer.uint32(32).int32(message.bathrooms);
        }
        if (message.sqft !== 0) {
            writer.uint32(40).int32(message.sqft);
        }
        if (message.monthsAgo !== 0) {
            writer.uint32(48).int32(message.monthsAgo);
        }
        if (message.distance !== 0) {
            writer.uint32(56).int32(message.distance);
        }
        if (message.statusId !== 0) {
            writer.uint32(64).int32(message.statusId);
        }
        if (message.standardStatus !== "") {
            writer.uint32(74).string(message.standardStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseZoopraisalRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.position = exports.ZoopraisalRequest_Coordinates.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.homeType = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.bedrooms = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.bathrooms = reader.int32();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.sqft = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.monthsAgo = reader.int32();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.distance = reader.int32();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.statusId = reader.int32();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.standardStatus = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            position: isSet(object.position) ? exports.ZoopraisalRequest_Coordinates.fromJSON(object.position) : undefined,
            homeType: isSet(object["home-type"]) ? globalThis.String(object["home-type"]) : "",
            bedrooms: isSet(object.bedrooms) ? globalThis.Number(object.bedrooms) : 0,
            bathrooms: isSet(object.bathrooms) ? globalThis.Number(object.bathrooms) : 0,
            sqft: isSet(object.sqft) ? globalThis.Number(object.sqft) : 0,
            monthsAgo: isSet(object.monthsAgo) ? globalThis.Number(object.monthsAgo) : 0,
            distance: isSet(object.distance) ? globalThis.Number(object.distance) : 0,
            statusId: isSet(object.statusId) ? globalThis.Number(object.statusId) : 0,
            standardStatus: isSet(object.standardStatus) ? globalThis.String(object.standardStatus) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.position !== undefined) {
            obj.position = exports.ZoopraisalRequest_Coordinates.toJSON(message.position);
        }
        if (message.homeType !== "") {
            obj["home-type"] = message.homeType;
        }
        if (message.bedrooms !== 0) {
            obj.bedrooms = Math.round(message.bedrooms);
        }
        if (message.bathrooms !== 0) {
            obj.bathrooms = Math.round(message.bathrooms);
        }
        if (message.sqft !== 0) {
            obj.sqft = Math.round(message.sqft);
        }
        if (message.monthsAgo !== 0) {
            obj.monthsAgo = Math.round(message.monthsAgo);
        }
        if (message.distance !== 0) {
            obj.distance = Math.round(message.distance);
        }
        if (message.statusId !== 0) {
            obj.statusId = Math.round(message.statusId);
        }
        if (message.standardStatus !== "") {
            obj.standardStatus = message.standardStatus;
        }
        return obj;
    },
    create(base) {
        return exports.ZoopraisalRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = createBaseZoopraisalRequest();
        message.position = (object.position !== undefined && object.position !== null)
            ? exports.ZoopraisalRequest_Coordinates.fromPartial(object.position)
            : undefined;
        message.homeType = (_a = object.homeType) !== null && _a !== void 0 ? _a : "";
        message.bedrooms = (_b = object.bedrooms) !== null && _b !== void 0 ? _b : 0;
        message.bathrooms = (_c = object.bathrooms) !== null && _c !== void 0 ? _c : 0;
        message.sqft = (_d = object.sqft) !== null && _d !== void 0 ? _d : 0;
        message.monthsAgo = (_e = object.monthsAgo) !== null && _e !== void 0 ? _e : 0;
        message.distance = (_f = object.distance) !== null && _f !== void 0 ? _f : 0;
        message.statusId = (_g = object.statusId) !== null && _g !== void 0 ? _g : 0;
        message.standardStatus = (_h = object.standardStatus) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
function createBaseZoopraisalRequest_Coordinates() {
    return { coordinates: [], type: "" };
}
exports.ZoopraisalRequest_Coordinates = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        writer.uint32(10).fork();
        for (const v of message.coordinates) {
            writer.double(v);
        }
        writer.join();
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseZoopraisalRequest_Coordinates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag === 9) {
                        message.coordinates.push(reader.double());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.coordinates.push(reader.double());
                        }
                        continue;
                    }
                    break;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            coordinates: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.coordinates)
                ? object.coordinates.map((e) => globalThis.Number(e))
                : [],
            type: isSet(object.type) ? globalThis.String(object.type) : "",
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.coordinates) === null || _a === void 0 ? void 0 : _a.length) {
            obj.coordinates = message.coordinates;
        }
        if (message.type !== "") {
            obj.type = message.type;
        }
        return obj;
    },
    create(base) {
        return exports.ZoopraisalRequest_Coordinates.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseZoopraisalRequest_Coordinates();
        message.coordinates = ((_a = object.coordinates) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseZoopraisalResponse() {
    return {
        averageDaysOnMarket: 0,
        averagePrice: 0,
        datasetAddresses: [],
        datasetCount: 0,
        highestPrice: 0,
        lowestPrice: 0,
        overAskingCount: 0,
    };
}
exports.ZoopraisalResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.averageDaysOnMarket !== 0) {
            writer.uint32(8).uint32(message.averageDaysOnMarket);
        }
        if (message.averagePrice !== 0) {
            writer.uint32(16).uint32(message.averagePrice);
        }
        for (const v of message.datasetAddresses) {
            writer.uint32(26).string(v);
        }
        if (message.datasetCount !== 0) {
            writer.uint32(32).uint32(message.datasetCount);
        }
        if (message.highestPrice !== 0) {
            writer.uint32(40).uint32(message.highestPrice);
        }
        if (message.lowestPrice !== 0) {
            writer.uint32(48).uint32(message.lowestPrice);
        }
        if (message.overAskingCount !== 0) {
            writer.uint32(56).uint32(message.overAskingCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseZoopraisalResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.averageDaysOnMarket = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.averagePrice = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.datasetAddresses.push(reader.string());
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.datasetCount = reader.uint32();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.highestPrice = reader.uint32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.lowestPrice = reader.uint32();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.overAskingCount = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            averageDaysOnMarket: isSet(object["average-days-on-market"])
                ? globalThis.Number(object["average-days-on-market"])
                : 0,
            averagePrice: isSet(object["average-price"]) ? globalThis.Number(object["average-price"]) : 0,
            datasetAddresses: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object["dataset-addresses"])
                ? object["dataset-addresses"].map((e) => globalThis.String(e))
                : [],
            datasetCount: isSet(object["dataset-count"]) ? globalThis.Number(object["dataset-count"]) : 0,
            highestPrice: isSet(object["highest-price"]) ? globalThis.Number(object["highest-price"]) : 0,
            lowestPrice: isSet(object["lowest-price"]) ? globalThis.Number(object["lowest-price"]) : 0,
            overAskingCount: isSet(object["over-asking-count"]) ? globalThis.Number(object["over-asking-count"]) : 0,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.averageDaysOnMarket !== 0) {
            obj["average-days-on-market"] = Math.round(message.averageDaysOnMarket);
        }
        if (message.averagePrice !== 0) {
            obj["average-price"] = Math.round(message.averagePrice);
        }
        if ((_a = message.datasetAddresses) === null || _a === void 0 ? void 0 : _a.length) {
            obj["dataset-addresses"] = message.datasetAddresses;
        }
        if (message.datasetCount !== 0) {
            obj["dataset-count"] = Math.round(message.datasetCount);
        }
        if (message.highestPrice !== 0) {
            obj["highest-price"] = Math.round(message.highestPrice);
        }
        if (message.lowestPrice !== 0) {
            obj["lowest-price"] = Math.round(message.lowestPrice);
        }
        if (message.overAskingCount !== 0) {
            obj["over-asking-count"] = Math.round(message.overAskingCount);
        }
        return obj;
    },
    create(base) {
        return exports.ZoopraisalResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseZoopraisalResponse();
        message.averageDaysOnMarket = (_a = object.averageDaysOnMarket) !== null && _a !== void 0 ? _a : 0;
        message.averagePrice = (_b = object.averagePrice) !== null && _b !== void 0 ? _b : 0;
        message.datasetAddresses = ((_c = object.datasetAddresses) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        message.datasetCount = (_d = object.datasetCount) !== null && _d !== void 0 ? _d : 0;
        message.highestPrice = (_e = object.highestPrice) !== null && _e !== void 0 ? _e : 0;
        message.lowestPrice = (_f = object.lowestPrice) !== null && _f !== void 0 ? _f : 0;
        message.overAskingCount = (_g = object.overAskingCount) !== null && _g !== void 0 ? _g : 0;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=zoopraisal.js.map